export class FormClass {
    constructor(formDomEl ) {

        this.formEl = formDomEl;

        this.formElements = this.formEl.querySelectorAll('input:not([type=submit]):not([type=hidden]), textarea');

    }
    
    resetForm(){

        const errorFields = this.formEl.querySelectorAll('.has-error, .has-success, .filled');

        console.log(errorFields)

        for (let j=0; j < errorFields.length; j++){
            errorFields[j].classList.remove('has-error');
            errorFields[j].classList.remove('has-success');
            errorFields[j].classList.remove('filled');
            let message = errorFields[j].querySelector('.messages');
            if (message) {
                message.innerHTML = '';
            }            
        }

        for (let i=0; i<this.formElements.length; i++){
            
            const el = this.formElements[i];
            if (el.type == "checkbox" || el.type=="radio"){
                this.formElements[i].checked = false;
            }else{
                this.formElements[i].value = "";
            }  

        }

    }

}
